import axios from 'axios'
import { getBubbleNodesInfo } from '../../utils/BubbleNodes'
import { DEFAULT_NAME_PROPERTY } from '../../utils/constants'

/* global Autodesk, THREE */
export let viewer
export let _instances
let _propertyNames
export let allBubbleNodes

const getForgeToken = async (callback) => {
  const token = await axios.get('/api/auth/token')
  callback(token.data.access_token, token.data.expires_in)
}

const getUrnViewer = () => {
  return viewer.model.getSeedUrn()
}

const loadScript = (url, namespace) => {
  if (window[namespace] !== undefined) {
    return Promise.resolve()
  }
  return new Promise(function (resolve, reject) {
    const el = document.createElement('script')
    el.src = url
    el.onload = resolve
    el.onerror = reject
    document.head.appendChild(el)
  })
}

const loadStylesheet = (url) => {
  return new Promise(function (resolve, reject) {
    const el = document.createElement('link')
    el.rel = 'stylesheet'
    el.href = url
    el.onload = resolve
    el.onerror = reject
    document.head.appendChild(el)
  })
}

const launchViewer = async (
  div,
  urn,
  setAreViewerDbIdsLoaded,
  setAllPropertyNames,
  selectedGuidViewCurrentModel
) => {
  const scriptsPromises = [
    loadScript(
      'https://developer.api.autodesk.com/modelderivative/v2/viewers/7.100/viewer3D.js',
      'Autodesk'
    ),
    loadStylesheet(
      'https://developer.api.autodesk.com/modelderivative/v2/viewers/7.100/style.css'
    ),
  ]

  await Promise.all(scriptsPromises)

  var options = {
    getAccessToken: getForgeToken,
    env: 'AutodeskProduction2',
    api: 'streamingV2',
  }

  Autodesk.Viewing.Initializer(options, () => {
    viewer = new Autodesk.Viewing.GuiViewer3D(document.getElementById(div), {
      extensions: ['Autodesk.DocumentBrowser'],
    })
    Autodesk.Viewing.theExtensionManager.unregisterExtension(
      'Autodesk.DocumentBrowser'
    )
    viewer.start()
    var spinners = document.getElementsByClassName('forge-spinner')
    var spinner = spinners[0]
    spinner.classList.remove('forge-spinner')
    spinner.classList.add('loader')
    spinner.innerHTML =
      "<img src='./Logo_BIMsualize.png'  class='viewer-spinner' />"
    setAreViewerDbIdsLoaded && setAreViewerDbIdsLoaded(false)
    setAllPropertyNames && setAllPropertyNames(false)
    viewer.setTheme('light-theme')

    var documentId = 'urn:' + urn.replace('/', '_')
    Autodesk.Viewing.Document.load(
      documentId,
      (doc) =>
        onDocumentLoadSuccess(
          doc,
          setAreViewerDbIdsLoaded,
          setAllPropertyNames,
          selectedGuidViewCurrentModel
        ),
      onDocumentLoadFailure
    )
  })
}

const onDocumentLoadSuccess = (
  doc,
  setAreViewerDbIdsLoaded,
  setAllPropertyNames,
  selectedGuidViewCurrentModel
) => {
  allBubbleNodes = getBubbleNodesInfo(doc)
  var viewables = selectedGuidViewCurrentModel
    ? doc.getRoot().findByGuid(selectedGuidViewCurrentModel[0].data.guid)
    : doc.getRoot().getDefaultGeometry()
  viewer.loadDocumentNode(doc, viewables).then((i) => {
    // any additional action here?
    viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, (event) => {
      return new Promise((resolve) => {
        startLeafNodes(setAreViewerDbIdsLoaded, setAllPropertyNames, viewables)
      })
    })
  })
}

const onDocumentLoadFailure = (viewerErrorCode, viewerErrorMsg) => {
  console.error(
    'onDocumentLoadFailure() - errorCode:' +
      viewerErrorCode +
      '\n- errorMessage:' +
      viewerErrorMsg
  )
}

const getAllLeafComponents = (viewer, callback) => {
  var cbCount = 0 // count pending callbacks
  var components = [] // store the results
  var tree // the instance tree

  function getLeafComponentsRec(parent) {
    cbCount++
    if (tree.getChildCount(parent) != 0) {
      tree.enumNodeChildren(
        parent,
        function (children) {
          getLeafComponentsRec(children)
        },
        false
      )
    } else {
      components.push(parent)
    }
    if (--cbCount == 0) callback(components)
  }
  viewer.getObjectTree(function (objectTree) {
    tree = objectTree
    getLeafComponentsRec(tree.getRootId())
  })
}

const startLeafNodesNwd = (setAreViewerDbIdsLoaded, setAllPropertyNames) => {
  viewer.model.getBulkProperties(null, ['GUID'], (res) => {
    const dbIds = res.map((item) => item.dbId)
    _instances = dbIds
    console.log('dbIdsNwd: ', dbIds)
    getAllPropertyNames(setAllPropertyNames)
    setAreViewerDbIdsLoaded && setAreViewerDbIdsLoaded(true)
  })
}

const startLeafNodesRvtNew = (
  setAreViewerDbIdsLoaded,
  setAllPropertyNames,
  viewables
) => {
  const viewableID =
    viewables.data.viewableID || viewer.model.getDocumentNode().data.guid

  // Sacamos todos los elementos con ElementId y viewable_in y filtramos por los que tengan ElementId y que alguno de sus viewable_in sea el de la vista actual
  viewer.model.getBulkProperties(null, ['ElementId', 'viewable_in'], (res) => {
    const dbIdsFiltered = res.filter(
      (item) =>
        item.properties.some(
          (prop) =>
            prop.displayName === 'viewable_in' &&
            prop.displayValue === viewableID
        ) && item.properties.some((prop) => prop.displayName === 'ElementId')
    )

    const dbIds = dbIdsFiltered.map((item) => item.dbId)
    console.log('dbIdsRvtNew: ', dbIds)
    _instances = dbIds
    getAllPropertyNames(setAllPropertyNames)
    setAreViewerDbIdsLoaded && setAreViewerDbIdsLoaded(true)
  })
}

const startLeafNodesRvt = (setAreViewerDbIdsLoaded, setAllPropertyNames) => {
  getAllLeafComponents(viewer, (dbIds) => {
    _instances = dbIds
    console.log('dbIdsRvt: ', dbIds)

    setAreViewerDbIdsLoaded && setAreViewerDbIdsLoaded(true)
    getAllPropertyNames(setAllPropertyNames)
    console.log('ya están los dbids!!!')
  })
}
const startLeafNodes = async (
  setAreViewerDbIdsLoaded,
  setAllPropertyNames,
  viewables
) => {
  const extension = getFileExtensionModel()
  const isSVF2 = viewer.model.isSVF2()
  console.log('isSVF2', isSVF2)
  switch (extension) {
    case 'nwc':
      return startLeafNodesNwd(setAreViewerDbIdsLoaded, setAllPropertyNames)
    case 'nwd':
      return startLeafNodesNwd(setAreViewerDbIdsLoaded, setAllPropertyNames)
    case 'rvt':
      return isSVF2
        ? startLeafNodesRvtNew(
            setAreViewerDbIdsLoaded,
            setAllPropertyNames,
            viewables
          )
        : startLeafNodesRvt(setAreViewerDbIdsLoaded, setAllPropertyNames)
    default:
      throw new Error('Extension file not found: ' + extension)
  }
}

const getPropertyNames = () => {
  if (_propertyNames) {
    return _propertyNames
  } else {
    return null
  }
}

const getAllPropertyNames = async (setAllPropertyNames) => {
  console.log('getAllPropertyName start')
  const promises = _instances.map(
    (dbId) =>
      new Promise((resolve) => {
        viewer.getProperties(dbId, (res) => {
          resolve(
            res.properties.map((p) => ({
              cat: p.displayCategory,
              name: p.displayName,
            }))
          )
        })
      })
  )

  const results = (await Promise.all(promises)).flat()
  console.log('getAllPropertyName finish promises')

  const hashTable = {}
  const unique = []
  for (const obj of results) {
    const key = obj.cat + obj.name
    if (!hashTable[key]) {
      hashTable[key] = true
      unique.push(obj)
    }
  }

  const grouped = unique.reduce((acc, obj) => {
    const category = obj.cat
    if (!acc[category]) {
      acc[category] = []
    }
    acc[category].push(obj)
    return acc
  }, {})
  console.log('getAllPropertyName finish')
  setAllPropertyNames(true)
  _propertyNames = grouped
  console.log('_propertyNames', _propertyNames)
  return grouped
}

const getDataAsync = (properties) => {
  return new Promise((resolve, reject) => {
    viewer.model.getBulkProperties(
      _instances,
      properties,
      (res) => {
        resolve(res)
      },
      (err) => reject(err)
    )
  })
}
const getModelFileName = () => {
  const fileName = viewer.model
    .getData()
    .loadOptions.bubbleNode.getRootNode()
    .children[0].name()
  const indexPoint = fileName.lastIndexOf('.')
  console.log('indexPoint', indexPoint)
  return fileName.substring(0, indexPoint)
}

const getFileExtensionModel = () => {
  return viewer?.model?.getData()?.loadOptions?.fileExt
}

const isSVF2 = () => {
  return viewer?.model?.isSVF2()
}
const getData = async (properties) => {
  const dataRaw = await getDataAsync(properties)
  const isNameSelected = properties.some((property) => property === 'name')
  const data = dataRaw.map((obj) => {
    const { dbId, properties, name } = obj
    const nuevasProperties = properties.map((prop) => {
      const { displayName, displayCategory, displayValue } = prop
      return {
        displayName,
        displayCategory,
        displayValue,
        key: `${displayCategory}/${displayName}`,
      }
    })
    return {
      dbId,
      properties: [
        ...nuevasProperties,
        ...(isNameSelected
          ? [
              {
                displayName: DEFAULT_NAME_PROPERTY.name,
                displayValue: name,
                displayCategory: DEFAULT_NAME_PROPERTY.cat,
              },
            ]
          : []),
      ],
    }
  })

  return data
}

const Helpers = {
  launchViewer,
  getData,
  getPropertyNames,
  getAllPropertyNames,
  getModelFileName,
  getFileExtensionModel,
  getUrnViewer,
  isSVF2,
}

export default Helpers
